export default __webpack_public_path__ + "static/media/computer-img.d064f04c.png";